import { AbstractCategory } from '../../data/types/categories';

export const GET_CATEGORIES_MINIMALIST = 'GET_CATEGORIES_MINIMALIST';
export const GET_CATEGORIES_MINIMALIST_SUCCESS =
  'GET_CATEGORIES_MINIMALIST_SUCCESS';
export const SET_LAST_FETCHED_CATEGORIES_MINIMALIST =
  'SET_LAST_FETCHED_CATEGORIES_MINIMALIST';
export const LOGOUT = 'LOGOUT';

export const actionGetCategoriesMinimalList = (payload?: {
  success?: (minimalCategoriesList: AbstractCategory[]) => void;
  error?: () => void;
}) => ({
  type: GET_CATEGORIES_MINIMALIST,
  payload,
});

export const actionGetCategoriesMinimalListSuccess = (payload: any) => ({
  type: GET_CATEGORIES_MINIMALIST_SUCCESS,
  payload,
});

export const actionSetLastFetchedCategoriesMinimalList = (
  timestamp: number,
) => ({
  type: SET_LAST_FETCHED_CATEGORIES_MINIMALIST,
  timestamp,
});

export const actionLogoutCategories = () => ({
  type: LOGOUT,
});
